import React, { useState } from 'react';
import axios from 'axios';

import {Configs} from '../api';
const AddInput =()=> {
    

const [name, setname] = useState('')
const adddata = async (e)=>{
  e.preventDefault();
  try {
  const result = await axios.post(Configs.locations,{name : name})
  console.log(result);
  window.location.reload();
}
  catch (error) {
    console.log(error.message);
}
}


           return ( 

<div align="center" className="container-fluid" >
    <h1 className="text-center mt-5">Locations</h1>
      <form className="d-flex mt-5 mb-5 algnItm" onSubmit={adddata} >
          <input type='text' 
          className="form-control input-styl "
          value={name}
          onChange={e=> setname(e.target.value)}
          required
          placeholder="Name"
          
        >
           </input>
          <button className="btn btn-success">add</button>


      </form>
    </div>
         );
    }

 
export default AddInput;
